<template>
  <div class="flex justify-between items-center mb-1 text-grayNeutralDark">
    <div class="flex items-center gap-1">
      <svg width="16" height="17">
        <use :xlink:href="`#${icon}`"></use>
      </svg>
      {{ label }}
    </div>
    <span><slot></slot></span>
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
  },
}
</script>
